import { Component, OnInit, Input } from '@angular/core';
import { AvatarService } from '../services/avatar.service';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input() userId: string;
  @Input() large: boolean;
  @Input() orgId: string;

  pixels = 55;

  url: string;

  constructor(private avatarService: AvatarService) { }

  ngOnInit() {
    if (this.large) {
      this.pixels = 80;
    }
    if (this.userId) {
      this.avatarService.getAvatarByUserId(this.userId)
        .filter(url => !!url)
        .subscribe(url => this.url = url);
    } else if (this.orgId) {
      this.avatarService.getAvatarByOrgId(this.orgId)
      .filter(url => !!url)
      .subscribe(url => this.url = url);
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/avatar/avatar.component.ts